import React, { useRef, useEffect } from 'react';

const VideoPlayer = ({ videoUrl, onVideoEnd }) => {
  const videoRef = useRef(null);
  

{
    console.log("videoUrl",`${process.env.REACT_APP_BUCKET_URL}${videoUrl}`)
}
  return (
    <div className="video-container ">
       <video
          width="100%"
          height="400"
          src={`${process.env.REACT_APP_BUCKET_URL}${videoUrl}`}
          controls
          onEnded={onVideoEnd}
        />
    </div>
  );
};

export default VideoPlayer;